<script lang="ts">
  import {type Component, onMount} from 'svelte'
  import type {Notification} from '../types'
  import api from '../api/api'
  import {t} from '../i18n'
  import CollectionFollowed from './CollectionFollowed.svelte'
  import ReceivedComment from './ReceivedComment.svelte'
  import ReceivedLike from './ReceivedLike.svelte'
  import ReceivedMessage from './ReceivedMessage.svelte'
  import ReceivedReply from './ReceivedReply.svelte'
  import UserFollowed from './UserFollowed.svelte'
  import ViewsAchievement from './ViewsAchievement.svelte'
  import PaginatedCollectionLoader from '../shared/PaginatedCollectionLoader.svelte'
  import {stopPropagation} from '../utils/event'

  export let onUpdated: () => any
  let notifications: Notification[] = []

  $: unreadNotifications = notifications.filter((n) => !n.read)
  $: readNotifications = notifications.filter((n) => n.read)

  async function readOpenedTimelines(unreadNotifications: Notification[]) {
    const ids = unreadNotifications.map((n) => n.id)

    if (ids.length > 0) {
      await api.put('/timelines/read', {timeline_ids: ids})
      unreadNotifications.forEach((n) => n.read = true)
    }

    onUpdated()
  }

  $: readOpenedTimelines(unreadNotifications)

  const componentMap = {
    collection_followed: CollectionFollowed,
    received_comment: ReceivedComment,
    received_like: ReceivedLike,
    received_message: ReceivedMessage,
    received_reply: ReceivedReply,
    user_followed: UserFollowed,
    views_achievement: ViewsAchievement
  } as Record<string, Component<any>>
</script>

{#if notifications.length > 0}
  {#each unreadNotifications as notification}
    <svelte:component this={componentMap[notification.timeline_type]}
                      {notification} notificationParams={notification.data}/>
  {/each}

  {#if unreadNotifications.length > 0 && readNotifications.length > 0}
    <div class="divider"/>
  {/if}

  {#each readNotifications as notification}
    <svelte:component this={componentMap[notification.timeline_type]}
                      {notification} notificationParams={notification.data}/>
  {/each}
{:else}
  <div class="item">
    <div class="notice-content">
      <span class="notice-action db">{t.timelines.empty}</span>
    </div>
  </div>
{/if}

<PaginatedCollectionLoader bind:items={notifications} url="/timelines" per={6} let:loadNext>
  <div class="divider"></div>
  <div class="item notice-load-wrap">
    <a class="notice-load-more" onclick={stopPropagation(loadNext)}>
      {t.notifications.load_more}
    </a>
  </div>
</PaginatedCollectionLoader>

<style global>
  :global(.notifications .item) {
    display: flex !important;
    gap: 30px;
  }
</style>